var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconGoogleSheets(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22,
    height: 30,
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fillRule: "evenodd",
    clipRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#23A566",
    d: "M21.35 28.266c0 .957-.77 1.734-1.718 1.734H1.717A1.726 1.726 0 0 1 0 28.266V1.742C0 .784.769.008 1.717.008h11.519l8.113 8.39v19.868Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1C8F5A",
    d: "m14.13 8.185 7.22 6.963-.022-6.761H14.94c-.29 0-.564-.074-.804-.202h-.005Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8ED1B1",
    d: "M21.35 8.386h-6.411a1.726 1.726 0 0 1-1.717-1.733V0l8.127 8.386Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M5.123 24.451h11.104v-9.708H5.123v9.708Zm6.238-6.587h3.492V16.13H11.36v1.734Zm0 2.658h3.492v-1.618H11.36v1.618Zm0 2.543h3.492v-1.503H11.36v1.503Zm-4.865 0h3.492v-1.503H6.496v1.503Zm0-2.543h3.492v-1.618H6.496v1.618Zm0-2.658h3.492V16.13H6.496v1.734Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconGoogleSheets);
export default __webpack_public_path__ + "static/media/icon-google-sheets.43593aae2a92cf935b9009b53e6b4445.svg";
export { ForwardRef as ReactComponent };